import { SVGIcon } from '../../atoms/SVG';
import { BtnModifier } from '../../molecules/Btn';

export enum TeamroomView {
  INVITE = 'invite',
  INVITE_UNREGISTERED = 'inviteUnregistered',
  JOIN = 'join',
  JOIN_REQUEST = 'joinRequest',
  LEAVE = 'leave',
  REQUEST_ACTIVATION = 'requestActivation',
  ACCEPT_ACTIVATION = 'acceptActivation',
  REJECT_ACTIVATION = 'rejectActivation',
}

export type ButtonVariant = 'anchor' | 'iconButton' | 'textButton';

export type ButtonConfig = {
  key: TeamroomView;
  icon: SVGIcon | undefined;
  variant: ButtonVariant;
  isModal: boolean;
  modifier?: BtnModifier | BtnModifier[];
  initialFocusIndex?: number;
};
